import { Icon } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Card, Button, Title } from 'UI';
import styles from './WorkflowToggleDialog.module.scss';

type Props = {
  subAccountCount: number;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function EditUncheckedToCheckedDialog({ subAccountCount, onConfirm, onCancel }: Props) {
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { t } = useTranslation('translations', {
    keyPrefix: 'TransactionApproval.Configuration.Workflows.Update.EditDialog.UncheckedToChecked',
  });

  return (
    <Card hoverEffect={false} className={styles.card}>
      <div className={styles.iconWrapper}>
        <Icon icon="cautionary2" size="xxlg" width="60px" height="60px" color="none" />
      </div>

      <Title level="4" className={styles.title}>
        {t('title', { defaultValue: 'Apply this workflow to all sub-accounts' })}
      </Title>

      <div className={styles.body}>
        <p className={styles.subtitle}>{t('subtitle', { defaultValue: 'Saving this change will:' })}</p>
        <ul className={styles.bullets}>
          <li>
            {t('bullet1', {
              count: subAccountCount,
              defaultValue: `Apply this workflow to all ${subAccountCount} sub-accounts where approval workflow is enabled.`,
            })}
          </li>
          <li>
            {t('bullet2', {
              defaultValue: 'Replace any existing approval workflow on those sub-accounts.',
            })}
          </li>
          <li>{t('bullet3', { defaultValue: 'Automatically apply to any new sub-accounts you create.' })}</li>
        </ul>
        <p className={styles.footer}>
          {t('footer', {
            defaultValue: 'Sub-accounts without approval workflow enabled will be skipped.',
          })}
        </p>
      </div>

      <div className={styles.controls}>
        <Button colorScheme="secondary" size="small" onClick={onCancel}>
          {tGlobal('Buttons.cancel', { defaultValue: 'Cancel' })}
        </Button>
        <Button colorScheme="primary" size="small" onClick={onConfirm}>
          {t('confirmButton', { defaultValue: 'Confirm' })}
        </Button>
      </div>
    </Card>
  );
}
